module.exports = __webpack_public_path__ + "static/media/shocking-fish.5b16c738.png";